'use strict';

module.exports = {
    locally: function () {
        /**
        * Fires ajax for partners
        */
        function revealPartners() {
            $('.js-product__message--partners').one('click', function () {
                var url = $('.locally-content').data('url');
                var sku = $('.product-detail').data('pid');
                var style = $('.product-detail').data('master-pid');
                if (typeof url !== 'undefined' && typeof sku !== 'undefined' && typeof style !== 'undefined') {
                    $.ajax({
                        url: url,
                        method: 'GET',
                        data: { productID: sku, masterID: style },
                        dataType: 'html',
                        success: function (html) {
                            $('.locally-content').empty().html(html);
                        },
                        error: function (xhr) {
                            var errorMessage = xhr.status + ': ' + xhr.statusText;
                            $('.locally-content').html(errorMessage);
                        }
                    });
                }
            });
        }

        revealPartners();
    }
};
